module.exports = __webpack_public_path__ + "img/add_user.47943b0f.svg";